import { render, staticRenderFns } from "./AddonGoogleLogin.vue?vue&type=template&id=5707ddbe&"
import script from "./AddonGoogleLogin.vue?vue&type=script&lang=js&"
export * from "./AddonGoogleLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports